const regexCharsForbidden = /[^A-Z\d./-]/i;
const regexCnpjWithOrWithoutMask =
  /^[A-Z\d]{2}\.?[A-Z\d]{3}\.?[A-Z\d]{3}\/?[A-Z\d]{4}-?\d{2}$/;
const regexCharsMask = /[./-]/g;
const regexCnpj = /^([A-Z\d]){12}(\d){2}$/;
const regexCnpjWithoutDv = /^([A-Z\d]){12}$/;
const cnpjZero = '00000000000000';
const sizeCnpjWithoutDv = 12;
const baseValue = '0'.charCodeAt(0);
const dvWeightList = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

function unmasked(cnpj: string): string {
  return cnpj.replace(regexCharsMask, '');
}

function dv(cnpj: string): [boolean, string] {
  if (!regexCharsForbidden.test(cnpj)) {
    const unmaskedCnpj = unmasked(cnpj);
    if (
      regexCnpjWithoutDv.test(unmaskedCnpj) &&
      unmaskedCnpj !== cnpjZero.substring(0, sizeCnpjWithoutDv)
    ) {
      let dv1Sum = 0;
      let dv2Sum = 0;
      for (let i = 0; i < sizeCnpjWithoutDv; i++) {
        const ascii = unmaskedCnpj.charCodeAt(i) - baseValue;
        dv1Sum += ascii * dvWeightList[i + 1];
        dv2Sum += ascii * dvWeightList[i];
      }
      const dv1 = dv1Sum % 11 < 2 ? 0 : 11 - (dv1Sum % 11);
      dv2Sum += dv1 * dvWeightList[sizeCnpjWithoutDv];
      const dv2 = dv2Sum % 11 < 2 ? 0 : 11 - (dv2Sum % 11);
      return [false, `${dv1}${dv2}`];
    }
  }
  return [true, ''];
}

export const cnpjValidator = (value: string) => {
  value = String(value);
  if (!regexCnpjWithOrWithoutMask.test(value)) {
    return false;
  }
  if (!regexCharsForbidden.test(value)) {
    const unmaskedValue = unmasked(value);
    if (regexCnpj.test(unmaskedValue) && unmaskedValue !== cnpjZero) {
      const cnpjDv = unmaskedValue.substring(sizeCnpjWithoutDv);
      const cnpjWithoutDv = unmaskedValue.substring(0, sizeCnpjWithoutDv);
      const [calculateError, calculatedDv] = dv(cnpjWithoutDv);
      if (calculateError) {
        return false;
      }
      return cnpjDv === calculatedDv;
    }
  }
  return false;
};
